import { render, staticRenderFns } from "./RetailerForm.vue?vue&type=template&id=7b2cda52&scoped=true&"
import script from "./RetailerForm.vue?vue&type=script&lang=ts&"
export * from "./RetailerForm.vue?vue&type=script&lang=ts&"
import style0 from "./RetailerForm.vue?vue&type=style&index=0&id=7b2cda52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2cda52",
  null
  
)

export default component.exports